/* src/app/forms/query-executor/query-executor-settings/query-executor-settings.component.scss */
.configuration-fields {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: auto;
  padding: 6px;
}
.view-component-title {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px 20px;
  background: var(--tem-surface-2);
}
.switch-label {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  cursor: pointer;
}
.actions-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.hdivider {
  margin: 4px 0;
}
.grid-face {
  display: flex;
  flex-direction: column;
  height: 100%;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  height: 100%;
}
.more-options {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: 10px;
  gap: 15px;
  padding-top: 10px;
}
.more-options-color {
  padding-top: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  height: 100%;
}
.customtextarea {
  height: 100%;
  resize: none;
}
.fields-grid {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding-top: 4px;
}
.tool-bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4px;
}
.panel-main {
  margin: 0px !important;
}
/*# sourceMappingURL=query-executor-settings.component.css.map */
